import { Authentication } from "@leedpulse-monorepo/classes";
import Failure from "../../../core/Failure";
import HttpClient from "../../../core/HttpClient";

interface RevokeRefreshTokensPayload {
    userUid: string;
    auth: Authentication;
}

async function revokeRefreshTokens({userUid, auth}: RevokeRefreshTokensPayload): Promise<void> {
    try {
        await HttpClient.post('/revoke_refresh_tokens', {
            userUid,
        }, auth.token);
    } catch (error) {
        throw new RevokeRefreshTokensFailure();
    }
}

export class RevokeRefreshTokensFailure extends Failure {
    constructor(message = 'Unknown error', code = 'unknown-error') {
        super(message, code);
    }
}

export default revokeRefreshTokens;